import { images, missionIcon, visionIcon } from "../source";

export const exloreData = [
  {
    id: "01",
    icon: missionIcon,
    img: images.mission.image,
    alt: images.mission.alt,
    title: "Interviews",
    desc: "Discover our interviews with thought leaders and experts from around the world.",
  },
  {
    id: "02",
    icon: visionIcon,
    img: images.vision.image,
    alt: images.vision.alt,
    bgColor: "#597931e6",
    title: "Relfections",
    desc: "Expand your perspective with diverse insights and perspectives",
  },
];

export const testimonialData = [
  {
    title: "Lorem ipsum dolor sit amet, consectetur tempor",
    desc: `I am truly impressed and inspired by the Pathways & Perspectives podcast hosted by Marouf. It is a one stop portal to various schools of thought to suit a variety of seekers and gives us an opportunity to find our own pathway to our true selves.
    <br><br>
    Everyone has something to gain from this unique and inspiring platform.
    <br><br>
    May the joy be with you!`,
    name: "Ra",
    img: images.testimonial01.image,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur tempor dummy text",
    desc: `A brilliant platform sharing relevant wisdom from different leading thought leaders and wisdom keepers, Maroufs knowledge and quick wit captive a wide range of audiences! Very honored to share the wisdom of Jyotish Astrology on Pathways & Perspectives!`,
    name: "Annemarie Brown",
    img: images.testimonial02.image,
    insta: "@annemariebrown_",
    instaLink: "https://www.instagram.com/annemariebrown_/",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur tempor dummy text",
    desc: `A wonderful teacher once told me ‘true knowledge is held in the field of silence - even you are not aware that you know it, but it pours out in response to a genuine question’.
    <br><br>
    My conversation with Marouf unfolded in a similar fashion, guided by his adventurous curiosity informed by the depth of his journey. We both have a shared desire for delving into the root of the matter, and the heart to go into uncharted territory in order to arrive at something more expansive and resonant.
    <br><br>
    I was inspired by the meeting, the setting and the warmth. I hope you’ll take away something useful for yourself in listening.
    `,
    name: "Monika Vijh",
    img: images.testimonial03.image,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur tempor dummy text",
    desc: `Being interviewed on Pathways and Perspectives was like sitting down with a dear friend — one who listens deeply and asks the kind of questions that open doors. As someone rooted in yoga and spiritual practice, I truly appreciated the spaciousness and presence of the exchange. This is a platform where authentic stories can truly land.`,
    name: "Charlotte Holmes",
    img: images.testimonial04.image,
    insta: "@misscharholmes",
    instaLink: "https://www.instagram.com/misscharholmes/",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur tempor",
    desc: `I am truly impressed and inspired by the Pathways & Perspectives podcast hosted by Marouf. It is a one stop portal to various schools of thought to suit a variety of seekers and gives us an opportunity to find our own pathway to our true selves.
    <br><br>
    Everyone has something to gain from this unique and inspiring platform.
    <br><br>
    May the joy be with you!`,
    name: "Ra",
    img: images.testimonial01.image,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur tempor dummy text",
    desc: `A brilliant platform sharing relevant wisdom from different leading thought leaders and wisdom keepers, Maroufs knowledge and quick wit captive a wide range of audiences! Very honored to share the wisdom of Jyotish Astrology on Pathways & Perspectives!`,
    name: "Annemarie Brown",
    img: images.testimonial02.image,
    insta: "@annemariebrown_",
    instaLink: "https://www.instagram.com/annemariebrown_/",
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur tempor dummy text",
    desc: `A wonderful teacher once told me ‘true knowledge is held in the field of silence - even you are not aware that you know it, but it pours out in response to a genuine question’.
    <br><br>
    My conversation with Marouf unfolded in a similar fashion, guided by his adventurous curiosity informed by the depth of his journey. We both have a shared desire for delving into the root of the matter, and the heart to go into uncharted territory in order to arrive at something more expansive and resonant.
    <br><br>
    I was inspired by the meeting, the setting and the warmth. I hope you’ll take away something useful for yourself in listening.
    `,
    name: "Monika Vijh",
    img: images.testimonial03.image,
  },
  {
    title: "Lorem ipsum dolor sit amet, consectetur tempor dummy text",
    desc: `Being interviewed on Pathways and Perspectives was like sitting down with a dear friend — one who listens deeply and asks the kind of questions that open doors. As someone rooted in yoga and spiritual practice, I truly appreciated the spaciousness and presence of the exchange. This is a platform where authentic stories can truly land.`,
    name: "Charlotte Holmes",
    img: images.testimonial04.image,
    insta: "@misscharholmes",
    instaLink: "https://www.instagram.com/misscharholmes/",
  },
];

export const partnerLogo = [
  {
    id: 1,
    img: images.skiddle.image,
    alt: images.skiddle.alt,
  },
  {
    id: 2,
    img: images.overleaf.image,
    alt: images.overleaf.alt,
  },
  {
    id: 3,
    img: images.optica.image,
    alt: images.optica.alt,
  },
  {
    id: 4,
    img: images.ayvens.image,
    alt: images.ayvens.alt,
  },
  {
    id: 5,
    img: images.tradingView.image,
    alt: images.tradingView.alt,
  },
  {
    id: 6,
    img: images.skiddle.image,
    alt: images.skiddle.alt,
  },
  {
    id: 7,
    img: images.overleaf.image,
    alt: images.overleaf.alt,
  },
  {
    id: 8,
    img: images.optica.image,
    alt: images.optica.alt,
  },
  {
    id: 9,
    img: images.ayvens.image,
    alt: images.ayvens.alt,
  },
  {
    id: 10,
    img: images.tradingView.image,
    alt: images.tradingView.alt,
  },
];

export const upcomingEventsData = [
  // {
  //   id: 1,
  //   img: images.event01.image,
  //   alt: images.event01.alt,
  //   status: "ONLINE",
  //   title: "Tommy Rosen – The Path to a Life of Freedom",
  //   date: "July 21, 2025",
  //   time: "2 Hours (2.00 pm - 4.00 pm)",
  // },
  // {
  //   id: 2,
  //   img: images.event02.image,
  //   alt: images.event02.alt,
  //   status: "ONLINE",
  //   title: "Dr. Ramkumar – The Simple Wisdom of Ayurveda for Living Well",
  //   date: "Coming soon",
  //   time: "2 Hours (2.00 pm - 4.00 pm)",
  // },
  // {
  //   id: 3,
  //   img: images.event05.image,
  //   alt: images.event05.alt,
  //   status: "ONLINE",
  //   title: "Monika Vijh – Breaking Free from the Golden Cage: A Journey Beyond Life and Limit",
  //   date: "Coming soon",
  //   time: "2 Hours (2.00 pm - 4.00 pm)",
  // },
  {
    id: 3,
    img: images.event06.image,
    alt: images.event06.alt,
    status: "ONLINE",
    title: "I Changed My Perspective On Life - Nothing Has Been The Same Since With Marouf Tirad",
    date: "Coming soon",
    time: "2 Hours (2.00 pm - 4.00 pm)",
  },
  // {
  //   id: 4,
  //   img: images.event04.image,
  //   alt: images.event04.alt,
  //   status: "ONLINE",
  //   title: "Gurmukh Khalsa – Kundalini, Madonna, and a Youthful Spirit",
  //   date: "Coming soon",
  //   time: "2 Hours (2.00 pm - 4.00 pm)",
  // },
  // {
  //   id: 3,
  //   img: images.event03.image,
  //   alt: images.event03.alt,
  //   status: "online",
  //   title: "Lorem ipsum dolor sit amet, consectetur tempor dummy text",
  //   date: "July 11, 2024",
  //   time: "2 Hours (2.00 pm - 4.00 pm)",
  // },
];

export const reflectionData = [
  {
    date: "06.04.2024",
    thumb: images.reflection01.image,
    title:
      "Lorem ipsum dolor sit amet, nostrud consectetur text aliqua dummy text",
    name: "Aryna Miller",
    ctaText: "KNOW MORE",
    ctaUrl: "",
  },
  {
    date: "21.03.2024",
    thumb: images.reflection01.image,
    title:
      "Lorem ipsum dolor sit amet, nostrud consectetur tempor dolore magna aliqua dummy text",
    name: "Chandler Perry",
    ctaText: "",
    ctaUrl: "",
  },
];
